module.exports = require('./lib/axios');


//////////////////
// WEBPACK FOOTER
// /Users/kentorry/Server/CLIENT-SERVER/CLIENT-WORK/afrodesiamedia/SERVER/afrodesiamedia/node_modules/axios/index.js
// module id = 208
// module chunks = 10